import React from "react";
import {connect} from 'dva';
import {framework_tool,component_tool, utils_tool} from '../../../tool'

import {templateConfig, reduxTemplateConfig} from './config';

let {WizContainer, WizReduxTemplate} = framework_tool
let {WizBrowserExport} = component_tool
let {Session} = utils_tool

class ApplicationColumnManager extends WizContainer {
  componentName = 'applicationColumnManager'

  constructor(props) {
    super(props);
    this.state = {}
    const {history} = props
    let applicationInfo = {}
    if (history.location && history.location.pathname === '/application/applicationManage/applicationManageToColumnDetail') {
      if (history.location && history.location.record) {
        applicationInfo = history.location.record
        Session.set('applicationInfo', applicationInfo)
      } else {
        applicationInfo = Session.get('applicationInfo') || {}
      }
    }
    this.applicationInfo = applicationInfo
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '应用名称',
        field: 'name',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '所属服务',
        field: 'applicationName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '分类',
        field: 'categoryName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '类型',
        field: 'type',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '适用终端',
        field: 'adapterNames',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '状态',
        field: 'status',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if(o['success']){
      let data = o['data']
      data && data.forEach(e => {
        e['type'] == 0 ? e['type'] = "独立应用" : e['type'] == 1 ? e['type'] = "内嵌应用" : e['type'] = "外链"
        e['status'] == 0 ? e['status'] = "禁用" : e['status'] == 1 ? e['status'] = "启用" : e['status'] = "待开发"
      })
      WizBrowserExport({
        title: '栏目应用信息',
        sheetName: '栏目应用信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '栏目应用信息.xlsx'
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _getPushProps = () => {
    let { location } = this.props;
    let applicationInfo = location['record'] && location['record'] ? location['record'] : undefined
    if (!applicationInfo) {
      applicationInfo = this.applicationInfo;
    }
    return applicationInfo
  }

  _render() {
    let pushProps = this._getPushProps()
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig({pushProps}),
      apiDataFormat: {
        add: this._handleCMD,
        export: this._handleFile
      },
      applicationId: pushProps && pushProps.id
    })
    return <WizReduxTemplate {..._reduxTemplateConfig}/>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ApplicationColumnManager);
